// Half Job logo — claw hammer + ½ in a rounded chocolate square.
// `size` controls the wordmark font size; the mark scales to size + 8.
// Wordmark colours and spacing intentionally match the previous logo so headers
// remain visually balanced across all screens.
export default function Logo({ size = 22, showWordmark = true }) {
  const mark = size + 8;
  return (
    <div className="flex items-center gap-2 select-none" data-testid="brand-logo">
      <img
        src="/logo.svg"
        alt="Half Job"
        width={mark}
        height={mark}
        style={{ width: mark, height: mark }}
        className="rounded-md shrink-0"
        draggable={false}
      />
      {showWordmark && (
        <span className="font-heading font-bold tracking-tight text-timber-900" style={{ fontSize: size }}>
          Half&nbsp;Job
        </span>
      )}
    </div>
  );
}
